module.exports = __webpack_public_path__ + "7818e99b.png";